module.exports = __webpack_public_path__ + "static/img/14000547.d56fffe6.png";